import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthService } from '../../Service/AuthService';
import { Box, Button, Typography } from '@mui/material';

const ConfirmAccount = () => {
  const { userId } = useParams();
  const [checkStatus, setCheckStatus] = useState({
    isConfirmed: false,
    text: '',
  });
  const navigate = useNavigate();
  useEffect(() => {
    let abortController = new AbortController();
    const confirmAccount = async () => {
      try {
        await AuthService.confirmAccount(
          userId as string,
          abortController.signal
        );

        setCheckStatus({
          isConfirmed: true,
          text: 'Your account has been confirmed!',
        });
      } catch (error: any) {
        if (error.message === 'Account already confirmed!') {
          setCheckStatus({
            isConfirmed: true,
            text: 'Your account has been already confirmed!',
          });
        } else {
          setCheckStatus({
            isConfirmed: false,
            text: 'Something went wrong! Please try again later!',
          });
        }
      }
    };
    confirmAccount();

    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <Box
      sx={{
        maxWidth: '100%',
        width: '100%',
        display: 'flex',
        padding: '20px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <form
        action=''
        style={{
          maxWidth: '472px',
          width: '100%',
        }}
      >
        <Box
          bgcolor={'#fff'}
          display={'flex'}
          flexDirection={'column'}
          p={'24px'}
          sx={{ boxShadow: '0px 2px 20px  rgba(29, 49, 55, 0.12)' }}
          borderRadius={'4px'}
          gap={'24px'}
        >
          <Typography textAlign={'center'} variant='h1'>
            {checkStatus.text}
          </Typography>
          <Button
            sx={{
              background: '#3293DB',
              color: '#fff',
              maxWidth: '100%',
              boxShadow: 'unset',
              fontSize: '14px',
              lineHeight: '17px',
            }}
            onClick={() => navigate('/')}
            type='submit'
            variant='contained'
          >
            Return to Log in
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default ConfirmAccount;
